// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__azTaF","image":"Header_image__1rXyk","name":"Header_name__dQkSz","info":"Header_info__2Nl5W","infoRow":"Header_infoRow__2hW_F"};